import * as React from 'react';
import { useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { notification, Row, Col, Typography } from 'antd';
import Parameters from 'shared/parameters';
import ResetPasswordForm from './ResetPasswordForm';
import { useHistory, useParams } from 'react-router-dom';

import '../Login.scss';
import { useTranslation } from 'react-i18next';

import { AuthConsumer } from 'shared/contexts/AuthContext';
import API_SERVICE from '../../../services/api-service';

interface Props {
    location: any;
}

const { Title } = Typography;
export default function ResetPassword({ location }: Props) {
    const { t } = useTranslation();
    const history = useHistory();
    const [fields, setFields] = useState([] as any[]);
    const [loading, setLoading] = useState(false);
    const RouteParams: any = useParams();
    const { from } = location.state || { from: { pathname: '/' } };
    if (RouteParams['token']) {
        return <AuthConsumer>
            {({ isAuth, updateAuthToken }) =>
                isAuth ? (
                    <Redirect to={from}/>
                ) : (
                    <Row gutter={20} className="login">
                        <Col flex={'auto'}/>
                        <Col flex={'400px'} className="login-form-wrapper">
                            <Title level={2}>{Parameters.ClientName}</Title>
                            <ResetPasswordForm
                                onChange={setFields}
                                fields={fields}
                                token={RouteParams['token']}
                                onRegister={async (d: any) => {
                                    setLoading(true);
                                    try {
                                        const { data: { message } } = await API_SERVICE.resetPassword({
                                            ...d,
                                            token: RouteParams['token'],
                                        });
                                        history.push('/login');
                                        notification.success({ message });
                                    } catch (e) {
                                        notification.error({
                                            message: t(API_SERVICE.handleErrors(e)),
                                        });
                                    }
                                    setLoading(false);
                                }}
                                loading={loading}
                            />
                            <Row gutter={20}>
                                <Col>
                                    <Link to="/login">
                                        {t('genDict.login')}
                                    </Link>
                                </Col>
                                <Col>
                                    <Link to="/reset-password">
                                        {t('genDict.resetPassword')}
                                    </Link>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )
            }
        </AuthConsumer>;
    }
    return (
        <AuthConsumer>
            {({ isAuth, updateAuthToken }) =>
                isAuth ? (
                    <Redirect to={from}/>
                ) : (
                    <Row gutter={20} className="login">
                        <Col flex={'auto'}/>
                        <Col flex={'400px'} className="login-form-wrapper">
                            <Title level={2}>{Parameters.ClientName}</Title>
                            <ResetPasswordForm
                                onChange={setFields}
                                fields={fields}
                                onRegister={async (d: any) => {
                                    setLoading(true);
                                    try {
                                        const { data: { message } } = await API_SERVICE.createResetPasswordToken({ ...d });
                                        notification.success({ message });
                                    } catch (e) {
                                        notification.error({
                                            message: t(API_SERVICE.handleErrors(e)),
                                        });
                                    }
                                    setLoading(false);
                                }}
                                loading={loading}
                            />
                            <Row gutter={20}>
                                <Col>
                                    <Link to="/login">
                                        {t('genDict.login')}
                                    </Link>
                                </Col>
                                <Col>
                                    <Link to="/reset-password">
                                        {t('genDict.resetPassword')}
                                    </Link>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                )
            }
        </AuthConsumer>
    );
}
